import { LotPicker } from '@/components/lots/lot-picker'
import { useProductLotSource } from '@/components/lots/lot-picker-source'
import { m } from '@/lib/paraglide/messages'

interface Props {
    productId?: string
    warehouseId?: string
    value?: string
    onChange: (lotId: string) => void
    disabled?: boolean
}

/** Ô chọn một lô thành phẩm còn tồn — tìm phía server, cuộn tải thêm. */
export function ProductLotPicker({
    productId,
    warehouseId,
    value,
    onChange,
    disabled,
}: Props) {
    const source = useProductLotSource({
        filters: {
            product_id: productId,
            warehouse_id: warehouseId,
            only_available: '1',
        },
    })
    return (
        <LotPicker
            source={source}
            value={value ?? ''}
            onChange={(id) => onChange(id)}
            disabled={disabled}
            placeholder={m.product_lot_picker_placeholder()}
            searchPlaceholder={m.product_lot_picker_search()}
        />
    )
}
